module.exports = __webpack_public_path__ + "static/media/class-selector-multiple.d59bd280.png";